import CityPageTemplate from "../city-template/CityPageTemplate";
import { seafordDeConfig } from "./data";

export default function SeafordDePage() {
  return <CityPageTemplate config={seafordDeConfig} />;
}